// client/src/modules/crm/nav.ts
import type { NavItem } from '../types';

/**
 * Navigation items for CRM module sidebar
 * CRM: Full sales funnel from prospecting through closed deals
 */
export const navItems: NavItem[] = [
  { label: 'Leads', path: '/crm/leads' },
  { label: 'Contacts', path: '/crm/contacts' },
  { label: 'Site Survey', path: '/crm/surveys' },
  { label: 'Follow-ups', path: '/crm/follow-ups' },
  { label: 'Outbound', path: '/crm/outbound' },
  {
    label: 'Analytics',
    path: '/crm/analytics',
    children: [
      { label: 'Won Jobs', path: '/crm/analytics/won' },
      { label: 'Pipeline', path: '/crm/analytics' },
      { label: 'Agent Activity', path: '/crm/agent-activity' },
    ],
  },
  { label: 'Settings', path: '/crm/settings' },
];
